import React, { useEffect, useRef, useState } from "react";
import Layout from "layout/layout";
import { useSwipeable } from "react-swipeable";
import { useSelector } from "react-redux";
import { RootState } from "store/store";
import AlertWellcome from "pages/auth/alert/AlertWellcome";
import { Bookmark, ChevronDown, ChevronUp, Ellipsis, Heart, Link, MessageCircle, SendHorizontalIcon, Share, Sticker, X } from "lucide-react";
import { Button } from "components/ui/button";
import useFollowingStore from "store/useFollowingStore";
import { AppLog } from "services";
import { StatusMsg } from "utils";
import { profileVerified } from "assets";
import { Virtuoso } from "react-virtuoso";
import { useLocation, useNavigate } from "react-router-dom";
import { Service } from "utils/services";
import GoogleFontLoader from "react-google-font-loader";
import { useInView } from "react-intersection-observer";
import FollowingVideoPlayer from "components/app/new-feed-post/new-feed-components/new-feed-video-player/FollowingVideoPlayer";
import FollowingAudioPlayer from "./components/FollowingAudioPlayer";
import FollowingImageAlbum from "./components/FollowingImageAlbum";
import ImageUrlProfile from "components/app/image-url/ImageUrlProfile";
import NewFeedDailogShare from "components/app/new-feed-post/new-feed-components/new-feed-dialogs/NewFeedDialogShare";
import { toast } from "react-toastify";
import Comment from "pages/profile-post-contents-page-view/post-component/Comment";
import { useSocket } from "services/SocketContext";
import EmojiPicker, { EmojiClickData, EmojiStyle } from "emoji-picker-react";
import { Textarea } from "components/ui/textarea";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFaceSmileBeam } from "@fortawesome/free-solid-svg-icons";
import StickerPicker from "pages/profile-post-contents-page-view/post-component/Stickers";
import { Card } from "components/ui/card";
import DialogFollowingComment from "components/app/dialog/dialog-following-comment/DialogFollowingComment";
import LinkifyText from "components/app/linkify/LinkifyText";
import "styles/virtuoso-scroll.css";
import { ShimmerFollowingComments, ShimmerFollowingPosts, ShimmerFollowingUserListLoading, ShimmerFollowingUserListLoadMore } from "components/app/shrimmer/Shrimmer";

import PostOption from "components/app/post-option/PostOption";
import LeftSideConetnetUserFollowersAndReachs from "components/app/left-side-contents/LeftSideContentUserFollowersAndReachs";
import { ScrollArea, ScrollBar } from "components/ui/scroll-area";
import UserList from "components/app/flipflop/user-list/UserList";
import { useWatchTime } from "store/useWatchTime";
import { Popover, PopoverContent, PopoverTrigger } from "components/ui/popover";
import NewFeedDailogBlock from "components/app/new-feed-post/new-feed-components/new-feed-dialogs/NewFeedDialogBlock";
import NewFeedDailogDeletePost from "components/app/new-feed-post/new-feed-components/new-feed-dialogs/NewFeedDialogDeletePost";
import NewFeedDialogReportPost from "components/app/new-feed-post/new-feed-components/new-feed-dialogs/NewFeedDialogReportPost";
import NewFeedDialogBoostPost from "components/app/new-feed-post/new-feed-components/new-feed-dialogs/NewFeedDialogBoostPost";
import FollowingLivePlayer from "./components/FollowingLivePlayer";

const Scroller = React.forwardRef<HTMLDivElement, React.HTMLProps<HTMLDivElement>>(({ style, ...props }, ref) => {
  return (
    <div
      ref={ref}
      style={{
        ...style,
        overflowY: "auto",
        height: "100%",
        contain: "strict",
        willChange: "transform",
        WebkitOverflowScrolling: "touch",
      }}
      className="virtuoso-scroller"
      {...props}
    />
  );
});

const Following: React.FC<{ tag: "following" | "search" }> = ({ tag }) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const navigate = useNavigate();
  const userId: string | null = searchParams.get("user_id");

  const [isMobile, setIsMobile] = useState(window.innerWidth < 1280);

  const {
    users,
    selectedUserId,
    usersAppRecord,
    posts,
    postsAppRecord,
    currentPost,
    setCurrentPost,
    comments,
    showComments,
    commentAppRecord,
    initializePage,
    fetchFollowingUsers,
    fetchFollowingPosts,
    onClickedLike,
    onClickedShare,
    onClickedFavorite,
    onToggleShowComment,
    fetchComments,
    fetchSubComments,
    requestReactionComment,
    requestReplyComment,
    requestSubmitComment,
    onClickedUser,
    topTenFollowers,
    topTenFollowerLoading,
    topTenReachs,
    topTenReachLoading,
  } = useFollowingStore();

  // * Track Time
  const { setActivePost, activePost } = useWatchTime();

  const [currentIndex, setCurrentIndex] = useState(0);
  const [showAlert, setShowAlert] = useState(false);
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const { ref: inViewRef, inView } = useInView({ threshold: 0.6 });

  const scrollTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  const isAuthenticated = useSelector((state: RootState) => state.auth.isAuthenticated);

  const [dialogShare, setDialogShare] = useState({
    isOpen: false,
    post: null,
  });

  const [dialogBlock, setDialogBlock] = useState({
    isOpen: false,
    post: null,
    optionKey: "",
  });

  // * ==== Comment ==== * //
  const { joinRoom, leaveRoom } = useSocket();
  const [replyingTo, setReplyingTo] = useState<number | null>(null);
  const [textComment, setTextComment] = useState("");
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const emojiPickerRef = useRef<HTMLDivElement>(null);
  const [sticker, setSticker] = useState<any>({});
  const [showStickerPicker, setShowStickerPicker] = useState(false);
  const stickerPickerRef = useRef<HTMLDivElement>(null);

  const [postOption, setPostOption] = useState<{
    isOpen: boolean;
    buttonRef: HTMLButtonElement | null;
    post: any;
  }>({
    isOpen: false,
    buttonRef: null,
    post: null,
  });

  // * ==== Comment ==== * //

  const handleReplyClick = (commentId: number) => {
    setReplyingTo(commentId);
  };

  const onHandleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      if (textComment) {
        requestSubmitComment(sticker, textComment);
        setTextComment("");
        setSticker({});
      }
    }
  };

  const onEmojiClick = (emojiData: EmojiClickData) => {
    setTextComment((prev) => prev + emojiData.emoji);
  };

  const loadMoreComments = () => {
    if (commentAppRecord.canLoadMore() === false || comments.length === 0) {
      return;
    } else {
      setTimeout(async () => {
        await fetchComments(false);
      }, 1000);
    }
  };

  // * ==== Functions ==== * //

  const onClickeFollowingUser = async (followingUser: any) => {
    try {
      onClickedUser(navigate, followingUser);
      setCurrentIndex(0);
    } catch (err) {
      AppLog.show({
        message: `[onClickeFollowingUser] catch onPosreactionClick ${err}`,
      });
    }
  };

  // Copy link post
  const onClickedCopyLink = async (post: any) => {
    try {
      const generatedLink = `${process.env.REACT_APP_URL}/post?post_id=${post?.provider_post_id}`;

      await Service.copyText(generatedLink).then((_) => {
        toast.success("Link copied!", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: true,
        });
      });

      // setLink(generatedLink);
      // setCopied();
    } catch (err) {
      AppLog.show({
        message: `[onClickedCopyLink] catch onPosreactionClick ${err}`,
      });
    }
  };

  // Popover Option
  const onOpenPostOption = (e: React.MouseEvent<HTMLButtonElement>, post: any) => {
    setPostOption({
      isOpen: true,
      buttonRef: e.currentTarget,
      post: post,
    });
  };

  const onClosePostOption = () => {
    setPostOption({
      isOpen: false,
      buttonRef: null,
      post: null,
    });
  };

  // Dialog Share
  const onOpenDialogShare = (post: any) => {
    try {
      setDialogShare({
        isOpen: true,
        post: post,
      });
    } catch (err) {
      AppLog.show({ message: `catch onPosreactionClick ${err}` });
    }
  };

  const [dialogBoostPost, setDialogBoostPost] = useState({
    isOpen: false,
    post: null,
  });

  const onOpenDialogBoostPost = (post: any) => {
    try {
      setDialogBoostPost({
        isOpen: true,
        post: post,
      });
    } catch (error) {
      AppLog.show({
        message: `[onOpenDialogBoostPost]`,
        status: StatusMsg.error,
        error,
      });
    }
  };

  // Dialog Blcok
  const onOpenDialogBlock = (post: any, optionKey: string) => {
    try {
      setDialogBlock({
        isOpen: true,
        post: post,
        optionKey: optionKey,
      });
    } catch (error) {
      AppLog.show({
        message: `[onOpenDialogBlock]`,
        status: StatusMsg.error,
        error,
      });
    }
  };

  const [dialogDeletePost, setDialogDeletePost] = useState({
    isOpen: false,
    post: null,
  });

  const onOpenDialogDeletePost = (post: any) => {
    try {
      setDialogDeletePost({
        isOpen: true,
        post: post,
      });
    } catch (error) {
      AppLog.show({
        message: `[onOpenDialogDeletePost]`,
        status: StatusMsg.error,
        error,
      });
    }
  };

  const [dialogReportPost, setDialogReportPost] = useState({
    isOpen: false,
    post: null,
  });

  const onOpenDialogReportPost = (post: any) => {
    try {
      setDialogReportPost({
        isOpen: true,
        post: post,
      });
    } catch (error) {
      AppLog.show({
        message: `[onOpenDialogReportPost]`,
        status: StatusMsg.error,
        error,
      });
    }
  };

  // Swipe handlers.
  const handlers = useSwipeable({
    onSwipedUp: () => {
      setCurrentIndex((prev) => Math.min(prev + 1, posts.length - 1));
    },
    onSwipedDown: () => {
      setCurrentIndex((prev) => Math.max(prev - 1, 0));
    },
    preventScrollOnSwipe: true,
    trackMouse: true,
  });

  const handleScrollUp = () => {
    setCurrentIndex((prev) => Math.max(prev - 1, 0));
  };

  const handleScrollDown = () => {
    setCurrentIndex((prev) => Math.min(prev + 1, posts.length - 1));
  };

  // * ==== UseEffect ==== * //

  // Initialize page.
  useEffect(() => {
    const loadInitialPage = async () => {
      try {
        setCurrentIndex(0);
        setCurrentPost(0);
        await initializePage(userId, tag).then(() => {
          setTimeout(() => {}, 1000);
        });
      } catch (error) {
        AppLog.show({
          message: `[loadInitialPage]`,
          status: StatusMsg.error,
          error,
        });
      }
    };
    loadInitialPage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tag]);

  // Tracking size responsive.
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1280);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Tracking current page and loading more content.
  useEffect(() => {
    if (currentIndex >= posts.length - 2 && posts.length > 0 && postsAppRecord.canLoadMore()) {
      setTimeout(() => {
        fetchFollowingPosts({ isRefresh: false });
      }, 1000);
    }

    if (posts.length > 0) {
      joinRoom(`${posts[currentIndex]?.provider_post_id}`);
      if (currentPost) leaveRoom(`${currentPost?.provider_post_id}`);

      // * Track Time
      const post = posts[currentIndex];

      if (posts[currentIndex] && activePost?.id !== post?.id) {
        setActivePost(post); // ✅ Let Zustand manage the timing logic
      }

      setCurrentIndex(currentIndex);
      setCurrentPost(currentIndex);
      if (postOption.isOpen) onClosePostOption();

      return () => {
        if (activePost?.id === post?.id) {
          setActivePost(null); // ✅ Reset when leaving the story
        }
      };
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentIndex, posts.length]);

  useEffect(() => {
    if (!isAuthenticated) setShowAlert(true);
  }, [isAuthenticated]);

  // Scroll & keyboard with debounce.
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (scrollTimeoutRef.current) return;
      if (e.key === "ArrowDown") {
        setCurrentIndex((prev) => Math.min(prev + 1, posts.length - 1));
      } else if (e.key === "ArrowUp") {
        setCurrentIndex((prev) => Math.max(prev - 1, 0));
      }
      scrollTimeoutRef.current = setTimeout(() => {
        scrollTimeoutRef.current = null;
      }, 500);
    };

    const handleWheel = (e: WheelEvent) => {
      if (scrollTimeoutRef.current) return;

      if (e.deltaY > 0) {
        setCurrentIndex((prev) => Math.min(prev + 1, posts.length - 1));
      } else if (e.deltaY < 0) {
        setCurrentIndex((prev) => Math.max(prev - 1, 0));
      }
      scrollTimeoutRef.current = setTimeout(() => {
        scrollTimeoutRef.current = null;
      }, 500);
    };

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("wheel", handleWheel);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("wheel", handleWheel);
    };
  }, [posts.length]);

  // * -------------- * //

  const loadMoreItems = () => {
    if (usersAppRecord.canLoadMore() === false || users.length === 0) {
      return;
    }

    setTimeout(async () => {
      await fetchFollowingUsers({ isRefresh: false });
    }, 1000);
  };

  // * ==== Layouts ==== * //

  const postContents = (post: any, index: number) => {
    if (post.media_type?.toLowerCase() === "photo") {
      const width = Service.toDouble(post?.post_attachments[0].attachment_media_width);
      const height = Service.toDouble(post?.post_attachments[0].attachment_media_height);
      const ratio = height === 0 ? 1 : width / height;

      return (
        <div className="flex w-full h-full relative overflow-hidden pointer-events-none rounded-lg">
          <div
            className="absolute inset-0 bg-cover bg-center bg-black opacity-50 blur-3xl"
            style={{
              backgroundImage: `url("${post?.post_attachments[0]?.attachment_thumbnail_image_file_src}")`,
            }}
          />

          <img
            src={post.post_attachments[0].attachment_media_image_file_src}
            alt="Post"
            className={`relative z-10  w-full h-auto  ${ratio >= 0 && ratio < 0.74 ? "object-cover" : "object-contain"}`}
            loading="lazy"
          />
        </div>
      );
    } else if (post.media_type?.toLowerCase() === "album") {
      return <FollowingImageAlbum post={post} />;
    } else if (post.media_type?.toLowerCase() === "video") {
      return (
        <FollowingVideoPlayer
          post={post}
          src={post.post_attachments?.[0]?.attachment_media_image_file_src}
          thubnail={post?.post_attachments[0]?.attachment_thumbnail_image_file_src}
          attachment={post?.post_attachments[0]}
          videoRefCallback={(el) => {
            videoRef.current = el;
            inViewRef(el);
          }}
          autoPlayInView={true}
        />
      );
    } else if (post.media_type?.toLowerCase() === "status") {
      let textPost = JSON.parse(post?.media_style);

      if (!textPost) {
        return <div>Status Not Found!</div>;
      } else {
        let subStringBackgroundColor: string = textPost?.background_color;
        let subStringColor: string = textPost?.text_style?.color;

        if (subStringBackgroundColor.length && subStringColor.length === 8) {
          subStringBackgroundColor = subStringBackgroundColor.substring(2);
          subStringColor = subStringColor.substring(2);
        } else {
          subStringColor = "ffffff";
          subStringBackgroundColor = "000000";
        }

        const textSize = textPost?.text_style?.font_size * 1.15;

        return (
          <div
            style={{
              overflow: "hidden",
              backgroundColor: `#${subStringBackgroundColor}`,
            }}
            className="flex w-full h-full items-center text-center justify-center rounded-lg p-2"
          >
            <GoogleFontLoader
              fonts={[
                {
                  font: `${textPost?.text_style?.font}`,
                  weights: [400],
                },
              ]}
            />
            <p
              style={{
                color: `#${subStringColor}`,
                fontSize: textSize,
                fontFamily: `${textPost?.text_style?.font}, sans-serif`,
              }}
              className="text-center whitespace-pre-line"
            >
              {textPost?.text}
            </p>
          </div>
        );
      }
    } else if (post.media_type?.toLowerCase() === "live") {
      return <FollowingLivePlayer post={post} />;
    } else {
      return <div>Content Not Found!</div>;
    }
  };

  return (
    <>
      {isAuthenticated ? (
        <div className="flex h-[calc(100vh-80px)] w-full relative flex-row justify-between">
          <div className="hidden lg:block sticky top-[80px] left-0 z-0">
            <div className="pl-1 w-[310px] lg:w-[310px]">
              <div className="space-y-2 flex flex-col justify-between h-[calc(100vh-90px)]">
                {location.pathname === "/following" ? (
                  usersAppRecord.isLoading() ? (
                    <ShimmerFollowingUserListLoading />
                  ) : (
                    <div className="w-full h-full space-y-2 mt-4 overflow-x-hidden px-1" onWheel={(e) => e.stopPropagation()}>
                      <Virtuoso
                        style={{ height: "100%" }}
                        data={users}
                        endReached={loadMoreItems}
                        context={{ usersAppRecord }}
                        overscan={2}
                        itemContent={(index, followingUser) => (
                          <div
                            key={followingUser.id}
                            className={`rounded-lg cursor-pointer max-w-full overflow-x-hidden  ${`${followingUser.id}` === selectedUserId ? "bg-muted" : ""}`}
                            onClick={() => onClickeFollowingUser(followingUser)}
                          >
                            <UserList user={followingUser} />
                          </div>
                        )}
                        components={{
                          Scroller,
                          Footer: () =>
                            usersAppRecord.isLoadingMore() ? (
                              <ShimmerFollowingUserListLoadMore />
                            ) : usersAppRecord.isNoLoadMore() ? (
                              <div className="w-full flex justify-center items-center pt-2">
                                <b>Nothing more to load!</b>
                              </div>
                            ) : null,
                        }}
                      />
                    </div>
                  )
                ) : (
                  <ScrollArea className="w-full h-full" onWheel={(e) => e.stopPropagation()}>
                    <LeftSideConetnetUserFollowersAndReachs
                      topTenFollowers={topTenFollowers}
                      topTenFollowerLoading={topTenFollowerLoading}
                      topTenReachs={topTenReachs}
                      topTenReachLoading={topTenReachLoading}
                    />
                    <ScrollBar orientation="vertical" />
                  </ScrollArea>
                )}
              </div>
            </div>
          </div>

          {postsAppRecord.isLoading() ? (
            <ShimmerFollowingPosts />
          ) : (
            <div className="flex flex-1">
              <div {...handlers} className="w-full h-full overflow-hidden touch-none">
                <div className="relative w-full h-full">
                  {[currentIndex - 1, currentIndex, currentIndex + 1].map((i) => {
                    const post = posts[i];
                    if (!post) return null;

                    return (
                      <div
                        key={i}
                        className="absolute top-0  w-full h-full transition-transform duration-500 ease-in-out flex flex-row justify-center py-3 "
                        style={{
                          transform: `translateY(${(i - currentIndex) * 100}%)`,
                          zIndex: i === currentIndex ? 10 : 0,
                        }}
                      >
                        <div className="flex aspect-[8/16] rounded-lg relative ">
                          {postContents(post, i)}

                          {post.media_title && post.media_type !== "video" && post.media_type !== "live" && (
                            <div
                              className={`absolute  w-full bg-gradient-to-t from-black/45 p-2 z-10 max-h-[50vh] overflow-y-auto bottom-0 rounded-b-lg`}
                              onWheel={(e) => e.stopPropagation()}
                            >
                              <div className="mt-2 text-white">
                                <LinkifyText text={post.media_title} target="_blank" />
                              </div>
                            </div>
                          )}
                        </div>

                        <div className="flex flex-col items-start justify-end ml-4 space-y-4">
                          <div className="absolute top-4 flex flex-col  space-y-2">
                            <div className="flex flex-row items-center space-x-2">
                              <Button variant="secondary" size="icon" className="w-12 h-12 rounded-full" onClick={(e) => onOpenPostOption(e, post)}>
                                <Ellipsis className="w-6 h-6" />
                              </Button>
                            </div>
                          </div>

                          <div className="absolute bottom-4 flex flex-col space-y-2">
                            <div className="flex flex-row  space-x-2">
                              <ImageUrlProfile user={post.user} className="w-12 h-12 rounded-full object-cover border shadow-md " isLinkProfile={true} />
                              <div className="hidden xl:flex flex-row justify-between items-center w-full">
                                <div className="flex flex-col">
                                  <div className="flex items-center space-x-2">
                                    <p className="text-sm font-medium ">{post.user.name}</p>
                                    {post.user.is_verified === "Yes" && <img src={profileVerified} alt="" style={{ width: 15, height: 15 }} />}
                                  </div>
                                  <div className="flex items-center space-x-2">
                                    <p className="text-xs ">
                                      {`${post.user.no_of_follower ? `${post.user.no_of_follower} Followers` : ""} 
                                    ${post.user.no_of_like ? `• ${post.user.no_of_like} Likes` : ""}
                                   `}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="flex flex-row items-center space-x-2">
                              <Button variant="secondary" size="icon" className="w-12 h-12  rounded-full" onClick={() => onClickedLike(post)}>
                                {`${post?.is_reaction_like}` === "1" ? <Heart className="w-6 h-6 fill-red-500 stroke-red-500" /> : <Heart className="w-6 h-6" />}
                              </Button>

                              {post?.reaction_like_count > 0 && <p className="text-sm">{post?.reaction_like_count}</p>}
                            </div>

                            <div className="flex flex-row items-center space-x-2">
                              <Button variant="secondary" size="icon" className="w-12 h-12  rounded-full" onClick={onToggleShowComment}>
                                <MessageCircle className="w-6 h-6" />
                              </Button>

                              {post?.comment_count > 0 && <p className="text-sm">{post?.comment_count}</p>}
                            </div>

                            <div className="flex flex-row items-center space-x-2">
                              <Button variant="secondary" size="icon" className="w-12 h-12  rounded-full" onClick={() => onClickedFavorite(post)}>
                                {`${post?.is_reaction_favorite}` === "1" ? <Bookmark className="w-6 h-6 fill-yellow-500 stroke-yellow-500" /> : <Bookmark className="w-6 h-6" />}
                              </Button>

                              {post?.reaction_favorite_count > 0 && <p className="text-sm">{post?.reaction_favorite_count}</p>}
                            </div>

                            <div className="flex flex-row items-center space-x-2">
                              <Button variant="secondary" size="icon" className="w-12 h-12  rounded-full" onClick={() => onOpenDialogShare(post)}>
                                <Share className="w-6 h-6" />
                              </Button>

                              {post?.reaction_share_count > 0 && <p className="text-sm">{post?.reaction_share_count}</p>}
                            </div>

                            <Button variant="secondary" size="icon" className="w-12 h-12  rounded-full" onClick={() => onClickedCopyLink(post)}>
                              <Link className="w-6 h-6" />
                            </Button>

                            {post.media_type !== "video" && post?.sound_url && <FollowingAudioPlayer src={post?.sound_url} title={post?.sound_title} />}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              {dialogShare.isOpen && (
                <NewFeedDailogShare
                  post={dialogShare.post}
                  onSuccess={(post) => onClickedShare(post)}
                  isDialogOpen={dialogShare.isOpen}
                  setIsDialogOpen={(isOpen) => setDialogShare({ ...dialogShare, isOpen })}
                />
              )}

              {/* Mobile Dialog (LG and below) */}
              {isMobile && showComments && <DialogFollowingComment isDialogOpen={showComments} setIsDialogOpen={(isOpen) => onToggleShowComment()} />}
            </div>
          )}

          {/* Desktop Sidebar (XL and above) */}
          {!isMobile && showComments && (
            <div className="xl:block  w-1/4  py-2 px-5 ">
              <Card className="flex flex-col h-full p-3" onWheel={(e) => e.stopPropagation()}>
                <div className="flex justify-between items-center">
                  <h1 className=" font-semibold text-lg">Comments</h1>
                  <div className=" flex items-center justify-center cursor-pointer rounded-full bg-gray-200 dark:bg-accent w-[28px] h-[28px]" onClick={onToggleShowComment}>
                    <X className=" size-5" />
                  </div>
                </div>

                {/* sub comment  */}
                <div className="h-full space-y-2 mt-4 " onWheel={(e) => e.stopPropagation()}>
                  {commentAppRecord.isLoading() ? (
                    <ShimmerFollowingComments />
                  ) : (
                    <Virtuoso
                      data={comments}
                      itemContent={(index, comment) => (
                        <Comment
                          replyingTo={replyingTo!}
                          onReplyClick={() => handleReplyClick(comment.id)}
                          key={comment.id}
                          comment={comment}
                          index={index}
                          submitReply={(data: any) => {
                            requestReplyComment(data);
                            handleReplyClick(-1);
                          }}
                          onClikcReact={() => requestReactionComment({ comment })}
                          fetchSubComments={fetchSubComments}
                        >
                          {comment.sub_comments?.data?.length > 0 && (
                            <div className="">
                              {comment.sub_comments.data.map((subComment: any, subIndex: number) => (
                                <Comment
                                  replyingTo={replyingTo!}
                                  onReplyClick={() => handleReplyClick(subComment.id)}
                                  key={subComment.id}
                                  comment={subComment}
                                  index={subIndex}
                                  submitReply={(data: any) => {
                                    requestReplyComment(data);
                                    handleReplyClick(-1);
                                  }}
                                  onClikcReact={() =>
                                    requestReactionComment({
                                      comment: subComment,
                                    })
                                  }
                                  fetchSubComments={fetchSubComments}
                                  isSubComment={true}
                                >
                                  {/* Recursively render deeper sub-comments */}
                                  {subComment.sub_comments?.data?.length > 0 && (
                                    <div className="">
                                      {subComment.sub_comments.data.map((nestedComment: any, nestedIndex: number) => (
                                        <Comment
                                          replyingTo={replyingTo!}
                                          onReplyClick={() => handleReplyClick(nestedComment.id)}
                                          key={nestedComment.id}
                                          comment={nestedComment}
                                          index={nestedIndex}
                                          submitReply={(data: any) => {
                                            requestReplyComment(data);
                                            handleReplyClick(-1);
                                          }}
                                          onClikcReact={() =>
                                            requestReactionComment({
                                              comment: nestedComment,
                                            })
                                          }
                                          fetchSubComments={fetchSubComments}
                                          isSubComment={true}
                                        >
                                          {nestedComment.sub_comments?.data?.length > 0 && (
                                            <div className="">
                                              {nestedComment.sub_comments.data.map((nestedComment_f: any, nestedIndex_f: number) => (
                                                <Comment
                                                  replyingTo={replyingTo!}
                                                  onReplyClick={() => handleReplyClick(nestedComment_f.id)}
                                                  key={nestedComment_f.id}
                                                  comment={nestedComment_f}
                                                  index={nestedIndex_f}
                                                  submitReply={(data: any) => {
                                                    requestReplyComment(data);
                                                    handleReplyClick(-1);
                                                  }}
                                                  onClikcReact={() =>
                                                    requestReactionComment({
                                                      comment: nestedComment_f,
                                                    })
                                                  }
                                                  isSubComment={true}
                                                />
                                              ))}
                                            </div>
                                          )}
                                        </Comment>
                                      ))}
                                    </div>
                                  )}
                                </Comment>
                              ))}
                            </div>
                          )}
                        </Comment>
                      )}
                      endReached={loadMoreComments}
                      overscan={200}
                    />
                  )}
                </div>
                {/* ----------text comments---------- */}
                <div className="flex flex-row  dark:bg-background  justify-center items-start space-x-2 w-full  ">
                  <ImageUrlProfile isLinkProfile={true} user={Service?.userAuth} className="cursor-pointer rounded-full w-7 h-7" alt="logo" />
                  <div className="flex flex-col space-y-2  w-full items-start justify-start">
                    <div className="border p-2 rounded-2xl w-full dark:bg-[#3A3B3C] ">
                      <div className="flex flex-col">
                        <Textarea
                          value={textComment}
                          onKeyDown={onHandleKeyDown}
                          maxLength={100}
                          onChange={(e) => setTextComment(e.target.value)}
                          className="border border-none min-h-[10px]  focus-visible:ring-0 focus-visible:ring-offset-0 w-full  px-0 py-0 rounded-none dark:bg-[#3A3B3C]"
                          placeholder="Add comment"
                        />

                        {/*------ new code ----- */}

                        <div className="flex justify-between items-center">
                          <div className="flex space-x-2 items-center">
                            <Popover>
                              <PopoverTrigger asChild>
                                <div className="flex w-8 h-8 rounded-full  bg-gray-200 text-center items-center justify-center">
                                  <FontAwesomeIcon
                                    icon={faFaceSmileBeam}
                                    className="text-gray-500 dark:text-gray-500 cursor-pointer size-5"
                                    onClick={() => setShowEmojiPicker((prev) => !prev)}
                                  />
                                </div>
                              </PopoverTrigger>
                              <PopoverContent className="w-92 bg-transparent border-none shadow-none">
                                <EmojiPicker
                                  reactionsDefaultOpen={false}
                                  onEmojiClick={onEmojiClick}
                                  emojiStyle={EmojiStyle.FACEBOOK}
                                  searchDisabled={true}
                                  skinTonesDisabled={true}
                                />
                              </PopoverContent>
                            </Popover>
                            <Popover>
                              <PopoverTrigger asChild>
                                <div className="flex w-8 h-8 rounded-full  bg-gray-200 text-center items-center justify-center">
                                  <Sticker className=" text-gray-700 dark:text-gray-500 size-5 font-extrabold cursor-pointer" onClick={() => setShowStickerPicker(true)} />
                                </div>
                              </PopoverTrigger>
                              <PopoverContent className="w-92 bg-transparent border-none shadow-none">
                                {showStickerPicker && (
                                  <StickerPicker
                                    stickerPickerRef={stickerPickerRef}
                                    onStickerSelect={(sticker) => {
                                      setShowStickerPicker(false);
                                      setSticker(sticker);
                                    }}
                                  />
                                )}
                              </PopoverContent>
                            </Popover>
                          </div>
                          <div className="flex w-8 h-8 rounded-full  bg-gray-200 text-center items-center justify-center ">
                            <SendHorizontalIcon
                              className={`cursor-pointer size-5 ${textComment || Object.keys(sticker).length !== 0 ? "text-yellow-400" : "text-gray-500 dark:text-gray-500"}`}
                              onClick={
                                !textComment && Object.keys(sticker).length === 0
                                  ? () => {}
                                  : () => {
                                      requestSubmitComment(sticker, textComment);
                                      setTextComment("");
                                      setSticker({});
                                    }
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    {Object.keys(sticker).length !== 0 ? (
                      <div className="relative sticker-image w-16 h-16">
                        <img src={sticker.thumbnail_url} alt={sticker.pack_name} />
                        <div
                          className=" absolute bg-gray-200 hover:bg-gray-300 -top-1 -right-2 w-5 h-5 rounded-full dark:bg-[#3A3B3C] flex items-center cursor-pointer justify-center hover:dark:bg-[#4E4F50]"
                          onClick={() => setSticker({})}
                        >
                          <X className="w-4 h-4 " />
                        </div>
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              </Card>
            </div>
          )}

          <div className="hidden md:block sticky left-0 z-10">
            <div className="flex flex-col max-w-[310px] lg:max-w-[310px] h-full space-y-2 justify-center items-end mr-4">
              <Button variant="secondary" size="icon" className="w-14 h-14 rounded-full " onClick={handleScrollUp}>
                <ChevronUp className="w-8 h-8" />
              </Button>
              <Button variant="secondary" size="icon" className="w-14 h-14 rounded-full " onClick={handleScrollDown}>
                <ChevronDown className="w-8 h-8" />
              </Button>
            </div>
          </div>
        </div>
      ) : (
        <AlertWellcome showAlert={showAlert} setShowAlert={setShowAlert} />
      )}

      {postOption.isOpen && (
        <PostOption
          isOpen={postOption.isOpen}
          onOpenChange={(_) => onClosePostOption()}
          post={postOption.post}
          buttonRef={postOption.buttonRef}
          handleOptionClick={(post, optionKey) => {
            if (optionKey === "share") {
              onOpenDialogShare(post);
            } else if (optionKey === "block_user") {
              onOpenDialogBlock(post, optionKey);
            } else if (optionKey === "boring_user") {
              onOpenDialogBlock(post, optionKey);
            } else if (optionKey === "delete") {
              onOpenDialogDeletePost(post);
            } else if (optionKey === "report") {
              onOpenDialogReportPost(post);
            } else if (optionKey === "boost_post") {
              onOpenDialogBoostPost(post);
            }
          }}
        />
      )}

      {dialogBoostPost.isOpen && (
        <NewFeedDialogBoostPost
          post={dialogBoostPost?.post}
          isDialogOpen={dialogBoostPost.isOpen}
          setIsDialogOpen={(isOpen) => setDialogBoostPost({ ...dialogBoostPost, isOpen })}
        />
      )}

      {/* Dailog Block User or Boring User */}
      {dialogBlock.isOpen && (
        <NewFeedDailogBlock
          post={dialogBlock.post}
          isDialogOpen={dialogBlock.isOpen}
          optionKey={dialogBlock.optionKey}
          setIsDialogOpen={(isOpen) => setDialogBlock({ ...dialogBlock, isOpen })}
        />
      )}

      {dialogDeletePost.isOpen && (
        <NewFeedDailogDeletePost
          post={dialogDeletePost?.post}
          isDialogOpen={dialogDeletePost.isOpen}
          setIsDialogOpen={(isOpen) => setDialogDeletePost({ ...dialogDeletePost, isOpen })}
        />
      )}

      {dialogReportPost.isOpen && (
        <NewFeedDialogReportPost
          post={dialogReportPost?.post}
          isDialogOpen={dialogReportPost.isOpen}
          setIsDialogOpen={(isOpen) => setDialogReportPost({ ...dialogReportPost, isOpen })}
        />
      )}
    </>
  );
};

export default Following;
